<template>
<div>
    <div class="records-list">
        <span>{{record.label}}</span>
        <b-btn v-if="record.label" variant="info" @click="handlerCancle(record.id)">{{$lang('刪除')}}</b-btn>
    </div>
</div>
</template>

<script>
import {
    $apis
} from "@/helper";
export default {
    data() {
        return {
            record: {},
            id: 0
        };
    },
    methods: {
        // 获取报名列表
        getFamilyRecord() {
            return new Promise((resolve, reject) => {
                $apis.family
                    .familyRecord()
                    .then(resp => {
                        resolve(resp);
                        let records = resp.data.records;
                        let id = localStorage.getItem("record-id");
                        this.id = id;
                        records.forEach(item => {
                            if (item.id == id) {
                                this.record = item;
                            }else{
                                this.record =[]
                            }
                        });
           
                    })
                    .catch(err => {
                        reject(err);
                    });
            });
        },
        //获取家庭成员
           getFamilyList() {
            return $apis.family
                .familyList()
                .then(resp => {
                    this.members = resp.data.members;
                    this.isReadOnly = resp.data.isReadOnly;
                    let countRecords = resp.data.countRecords;
                    let length = resp.data.members.filter(item => !item.isAdult).length;
                    this.regComp = countRecords === 0 || !(length == countRecords);
                })
                .catch(err => {
                    console.log(err);
                });
        },
        // 提交报名
        submitFamilyRecord() {
            return new Promise((resolve, reject) => {
                $apis.family
                    .submitFamilyRecord({
                        id: this.id
                    })
                    .then(resp => {
                        resolve(true)
                    })
                    .catch(err => {
                        console.log(err);
                        this.notification.warning(err.message);
                        this.$emit('errs')
                        reject(false)
                    });
            });
        },
        // 刪除報名表
           handlerCancle(id) {
            var r = confirm(this.$lang("是否刪除報名表!"));
            if (r == true) {
                this.cancelFamilyRecord(id);
            }
        },
        cancelFamilyRecord(id) {
            $apis.family
                .cancelFamilyRecord({
                   id:id
                })
                .then(resp => {
                    console.log(resp);
                    this.getFamilyRecord();
                    this.getFamilyList();
                    localStorage.removeItem("record-id")
                    console.log(localStorage.getItem("record-id"));
                 this.notification.success(this.$lang("刪除成功"));
                     
                })
                .catch(err => {
                    console.log(err);
                });
        }
    }
};
</script>
